import React from 'react';
import PropTypes from 'prop-types';
import { MaintenancePage } from '@resy/ui-kitchen';

// Adapts the Angular injections to the shared MaintenancePage, which the widget
// renders directly. The full-screen framing comes from the `MaintenancePageOverlay`
// class on the `resy-maintenance` element in index.ejs.
const MaintenancePageContainer = (props) => {
  const {
    Analytics,
    $rootScope,
  } = props;

  return (
    <MaintenancePage
      Analytics={Analytics}
      maintenance={$rootScope?.maintenance}
    />
  );
};

MaintenancePageContainer.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    maintenance: PropTypes.shape({
      endTime: PropTypes.string,
      endDate: PropTypes.string,
    }),
  }).isRequired,
};

export default MaintenancePageContainer;
